import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import "./ConfigMultiplicadores.css";

const ConfigMultiplicadores = ({ isOpen, toggleOpen }) => {
  const [config, setConfig] = useState(null);
  const [cargando, setCargando] = useState(false);

  useEffect(() => {
    if (isOpen) {
      fetchConfig();
    }
  }, [isOpen]);

  const fetchConfig = async () => {
    try {
      setCargando(true);
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/config/multiplicadores`);
      setConfig(res.data);
    } catch (error) {
      console.error("Error al cargar configuración", error);
      Swal.fire("Error", "No se pudo cargar la configuración de multiplicadores", "error");
    } finally {
      setCargando(false);
    }
  };

  const handleGuardar = async () => {
    try {
      setCargando(true);
      await axios.put(`${process.env.REACT_APP_API_URL}/config/multiplicadores`, config);
      Swal.fire({
        title: "Guardado",
        text: "La configuración se ha guardado correctamente.",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al guardar", error);
      Swal.fire("Error", "No se pudo guardar la configuración", "error");
    } finally {
      setCargando(false);
    }
  };

  const handleChange = (grupo, campo, subcampo, valor) => {
    const valObj = parseInt(valor) || 0;
    setConfig((prev) => {
      const nuevo = { ...prev };
      if (subcampo) {
        nuevo[grupo][campo][subcampo] = valObj;
      } else {
        nuevo[grupo][campo] = valObj;
      }
      return nuevo;
    });
  };

  return (
    <div className={`multiplicadores-panel ${isOpen ? "open" : "closed"}`}>
      <div className="multiplicadores-header" onClick={toggleOpen}>
        <h2>Multiplicadores de Pedidos {isOpen ? "▼" : "▲"}</h2>
      </div>

      {isOpen && (
        <div className="multiplicadores-content">
          {cargando && !config ? (
            <p>Cargando...</p>
          ) : config ? (
            <div className="config-form">
              <h3>GC</h3>
              <div className="config-row">
                <label>Normal (General):</label>
                <input
                  type="number"
                  value={config.gc.normal}
                  onChange={(e) => handleChange("gc", "normal", null, e.target.value)}
                />
              </div>
              <div className="config-row">
                <label>Extendido (General):</label>
                <input
                  type="number"
                  value={config.gc.extendido}
                  onChange={(e) => handleChange("gc", "extendido", null, e.target.value)}
                />
              </div>

              <h4>Sucursales Especiales (GC)</h4>
              <p className="subtext">Aplica para: {config.gc.especiales.sucursales.join(", ")}</p>
              <div className="config-row">
                <label>Normal (Especial):</label>
                <input
                  type="number"
                  value={config.gc.especiales.normal}
                  onChange={(e) => handleChange("gc", "especiales", "normal", e.target.value)}
                />
              </div>
              <div className="config-row">
                <label>Extendido (Especial):</label>
                <input
                  type="number"
                  value={config.gc.especiales.extendido}
                  onChange={(e) => handleChange("gc", "especiales", "extendido", e.target.value)}
                />
              </div>

              <hr />

              <h3>GP</h3>
              <div className="config-row">
                <label>Normal:</label>
                <input
                  type="number"
                  value={config.gp.normal}
                  onChange={(e) => handleChange("gp", "normal", null, e.target.value)}
                />
              </div>
              <div className="config-row">
                <label>Extendido:</label>
                <input
                  type="number"
                  value={config.gp.extendido}
                  onChange={(e) => handleChange("gp", "extendido", null, e.target.value)}
                />
              </div>

              <button className="btn-guardar" onClick={handleGuardar} disabled={cargando}>
                {cargando ? "Guardando..." : "Guardar Cambios"}
              </button>
            </div>
          ) : (
            <p className="error-text">No se pudo cargar la info.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default ConfigMultiplicadores;
